import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import { FixedStageApi } from './api';
import { FixedStageApiKey } from './publicApiKey';
import { fixedStage } from '#packages/util';
import {
  EditorAPIKey,
  SelectionApiKey,
  ComponentsApiKey,
} from '#packages/apis';

export class Scope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  selection = this.useDependency(SelectionApiKey);
  components = this.useDependency(ComponentsApiKey);
}

export const FixedStageEntryPoint = createEntryPoint({
  name: 'FixedStage',
  Scope,
  publicApi({ contributeApi }) {
    contributeApi(FixedStageApiKey, FixedStageApi);
  },
  initialize() {
    if (fixedStage.isFixedStageEnabled()) {
      // TODO - when editorType is ready - https://jira.wixpress.com/browse/HTMLSRVR-5585
      // TODO: remove this whole block. this is temporary for internal testing until editorType is integrated.
      window.editorModel.siteHeader.documentType = 'fluidDocument';
    }
  },
});
